module.exports = __webpack_public_path__ + "img/banner1.ea06c642.png";